<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->


document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.faq-item h3').forEach(function (h) {
    const item = h.parentElement;
    const ans = item.querySelector('.faq-answer');

    // Ensure closed on load
    ans.style.maxHeight = '0px';

    h.addEventListener('click', function () {
      const isOpen = item.classList.toggle('open');
      if (isOpen) {
        ans.style.maxHeight = ans.scrollHeight + 'px';
      } else {
        ans.style.maxHeight = '0px';
      }
    });

    // Optional: recompute on resize for wrapping changes
    window.addEventListener('resize', function () {
      if (item.classList.contains('open')) {
        ans.style.maxHeight = ans.scrollHeight + 'px';
      }
    });
  });
});